var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg24HoursService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    id: "24-hours-service",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15,26a1,1,0,0,1-1,1A11,11,0,1,1,25,16a1,1,0,0,1-2,0,9,9,0,1,0-9,9A1,1,0,0,1,15,26ZM13,10v5H10a1,1,0,0,0,0,2h4a1,1,0,0,0,1-1V10a1,1,0,0,0-2,0Zm8,8H17a1,1,0,0,0,0,2h3v1H17a1,1,0,0,0-1,1v3a1,1,0,0,0,1,1h4a1,1,0,0,0,0-2H18V23h3a1,1,0,0,0,1-1V19A1,1,0,0,0,21,18Zm7,0a1,1,0,0,0-1,1v2H25V19a1,1,0,0,0-2,0v3a1,1,0,0,0,1,1h3v2a1,1,0,0,0,2,0V19A1,1,0,0,0,28,18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24HoursService);
export default __webpack_public_path__ + "static/media/24-hours-service.29ffbd97fc5607bd4e4fb48672350438.svg";
export { ForwardRef as ReactComponent };